import { CUSTOM_FIELD_TYPES } from "../types/index.js";
import { CASE_STATUS_LABELS } from "./caseStatues.js";
export const EXPORT_TABLES = {
    CASES: "Cases",
    FUNDING: "Funding",
    CUSTOM_FIELDS: "CustomFields",
    RESPONDENTS: "Respondents",
    CLINICAL_CONDITIONS: "ClinicalConditions",
};
// List of all allowed keys for the builder details
export const EDITABLE_COLUMN_KEYS = {
    RESPONDENT_FIRST_NAME: "RESPONDENT_FIRST_NAME",
    RESPONDENT_LAST_NAME: "RESPONDENT_LAST_NAME",
    RESPONDENT_EMAIL_ADDRESS: "RESPONDENT_EMAIL_ADDRESS",
    RESPONDENT_INDIGENOUS_STATUS: "RESPONDENT_INDIGENOUS_STATUS",
    RESPONDENT_DATE_OF_BIRTH: "RESPONDENT_DATE_OF_BIRTH",
    RESPONDENT_DEVELOPMENTAL_AGE: "RESPONDENT_DEVELOPMENTAL_AGE",
    RESPONDENT_SOURCE: "RESPONDENT_SOURCE",
    RESPONDENT_SOURCE_ID: "RESPONDENT_SOURCE_ID",
    RESPONDENT_CARE_TYPE: "RESPONDENT_CARE_TYPE",
    RESPONDENT_CARE_TYPE_CATEGORY: "RESPONDENT_CARE_TYPE_CATEGORY",
    RESPONDENT_CARE_TYPE_PROVIDER_AGENCY: "RESPONDENT_CARE_TYPE_PROVIDER_AGENCY",
    RESPONDENT_ORDER_TYPE: "RESPONDENT_ORDER_TYPE",
    RESPONDENT_CASE_TEAM: "RESPONDENT_CASE_TEAM",
    RESPONDENT_SEX: "RESPONDENT_SEX",
    RESPONDENT_CONTACT_EMAIL: "RESPONDENT_CONTACT_EMAIL",
    RESPONDENT_CONTACT_MOBILE_PHONE: "RESPONDENT_CONTACT_MOBILE_PHONE",
    RESPONDENT_OTP: "RESPONDENT_OTP",
    RESPONDENT_OTP_CREATED_AT: "RESPONDENT_OTP_CREATED_AT",
    RESPONDENT_SPLOSE_ID: "RESPONDENT_SPLOSE_ID",
    CASE_ID: "CASE_ID",
    CASE_CLAIM_NUMBER: "CASE_CLAIM_NUMBER",
    CASE_TITLE: "CASE_TITLE",
    CASE_DESCRIPTION: "CASE_DESCRIPTION",
    CASE_STATUS: "CASE_STATUS",
    CASE_CATEGORY: "CASE_CATEGORY",
    CASE_OPENED_AT: "CASE_OPENED_AT",
    CASE_CLOSED_AT: "CASE_CLOSED_AT",
    CASE_REFERRAL_DATE: "CASE_REFERRAL_DATE",
    CASE_OCCUPATION_STATUS: "CASE_OCCUPATION_STATUS",
    CASE_SUB_CATEGORY: "CASE_SUB_CATEGORY",
    CASE_FLAG: "CASE_FLAG",
    CASE_FLAG_NOTES: "CASE_FLAG_NOTES",
    CASE_FUNDING_AMOUNT: "CASE_FUNDING_AMOUNT",
    CASE_OUTCOME: "CASE_OUTCOME",
    CLINICAL_CONDITION_NAME: "CLINICAL_CONDITION_NAME",
    CLINICAL_CONDITION_TYPE: "CLINICAL_CONDITION_TYPE",
    CLINICAL_CONDITION_DESCRIPTION: "CLINICAL_CONDITION_DESCRIPTION",
    CLINICAL_CONDITION_CAUSE: "CLINICAL_CONDITION_CAUSE",
    CLINICAL_CONDITION_ONSET_AT: "CLINICAL_CONDITION_ONSET_AT",
    CLINICAL_CONDITION_REPORTED_AT: "CLINICAL_CONDITION_REPORTED_AT",
    CLINICAL_CONDITION_IS_WORK_RELATED: "CLINICAL_CONDITION_IS_WORK_RELATED",
    CLINICAL_CONDITION_SEVERITY: "CLINICAL_CONDITION_SEVERITY",
    CLINICAL_CONDITION_STATUS: "CLINICAL_CONDITION_STATUS",
    CLINICAL_CONDITION_NOTES: "CLINICAL_CONDITION_NOTES",
    FUNDING_NAME: "FUNDING_NAME",
    FUNDING_CODE: "FUNDING_CODE",
    FUNDING_TYPE: "FUNDING_TYPE",
    FUNDING_DESCRIPTION: "FUNDING_DESCRIPTION",
    FUNDING_STARTS_AT: "FUNDING_STARTS_AT",
    FUNDING_ENDS_AT: "FUNDING_ENDS_AT",
    FUNDING_STATUS: "FUNDING_STATUS",
    FUNDING_CURRENCY: "FUNDING_CURRENCY",
    FUNDING_AMOUNT: "FUNDING_AMOUNT",
};
export const EDITABLE_COLUMN_DETAILS = [
    {
        key: EDITABLE_COLUMN_KEYS.RESPONDENT_FIRST_NAME,
        sourceTable: EXPORT_TABLES.RESPONDENTS,
        sourceColumn: "firstName",
        displayLabel: "First Name",
        type: CUSTOM_FIELD_TYPES.TEXT,
    },
    {
        key: EDITABLE_COLUMN_KEYS.RESPONDENT_LAST_NAME,
        sourceTable: EXPORT_TABLES.RESPONDENTS,
        sourceColumn: "lastName",
        displayLabel: "Last Name",
        type: CUSTOM_FIELD_TYPES.TEXT,
    },
    {
        key: EDITABLE_COLUMN_KEYS.RESPONDENT_EMAIL_ADDRESS,
        sourceTable: EXPORT_TABLES.RESPONDENTS,
        sourceColumn: "emailAddress",
        displayLabel: "Email Address",
        type: CUSTOM_FIELD_TYPES.TEXT,
    },
    {
        key: EDITABLE_COLUMN_KEYS.RESPONDENT_INDIGENOUS_STATUS,
        sourceTable: EXPORT_TABLES.RESPONDENTS,
        sourceColumn: "indigenousStatus",
        displayLabel: "Indigenous Status",
        type: CUSTOM_FIELD_TYPES.TEXT,
    },
    {
        key: EDITABLE_COLUMN_KEYS.RESPONDENT_DATE_OF_BIRTH,
        sourceTable: EXPORT_TABLES.RESPONDENTS,
        sourceColumn: "dateOfBirth",
        displayLabel: "Date of Birth",
        type: CUSTOM_FIELD_TYPES.DATE,
    },
    {
        key: EDITABLE_COLUMN_KEYS.RESPONDENT_DEVELOPMENTAL_AGE,
        sourceTable: EXPORT_TABLES.RESPONDENTS,
        sourceColumn: "developmentalAge",
        displayLabel: "Developmental Age",
        type: CUSTOM_FIELD_TYPES.NUMBER,
    },
    {
        key: EDITABLE_COLUMN_KEYS.RESPONDENT_SOURCE,
        sourceTable: EXPORT_TABLES.RESPONDENTS,
        sourceColumn: "source",
        displayLabel: "Source",
        type: CUSTOM_FIELD_TYPES.TEXT,
    },
    {
        key: EDITABLE_COLUMN_KEYS.RESPONDENT_SOURCE_ID,
        sourceTable: EXPORT_TABLES.RESPONDENTS,
        sourceColumn: "sourceId",
        displayLabel: "Source ID",
        type: CUSTOM_FIELD_TYPES.TEXT,
    },
    {
        key: EDITABLE_COLUMN_KEYS.RESPONDENT_CARE_TYPE,
        sourceTable: EXPORT_TABLES.RESPONDENTS,
        sourceColumn: "careType",
        displayLabel: "Care Type",
        type: CUSTOM_FIELD_TYPES.TEXT,
    },
    {
        key: EDITABLE_COLUMN_KEYS.RESPONDENT_CARE_TYPE_CATEGORY,
        sourceTable: EXPORT_TABLES.RESPONDENTS,
        sourceColumn: "careTypeCategory",
        displayLabel: "Care Type Category",
        type: CUSTOM_FIELD_TYPES.TEXT,
    },
    {
        key: EDITABLE_COLUMN_KEYS.RESPONDENT_CARE_TYPE_PROVIDER_AGENCY,
        sourceTable: EXPORT_TABLES.RESPONDENTS,
        sourceColumn: "careTypeProviderAgency",
        displayLabel: "Care Type Provider Agency",
        type: CUSTOM_FIELD_TYPES.TEXT,
    },
    {
        key: EDITABLE_COLUMN_KEYS.RESPONDENT_ORDER_TYPE,
        sourceTable: EXPORT_TABLES.RESPONDENTS,
        sourceColumn: "orderType",
        displayLabel: "Order Type",
        type: CUSTOM_FIELD_TYPES.TEXT,
    },
    {
        key: EDITABLE_COLUMN_KEYS.RESPONDENT_CASE_TEAM,
        sourceTable: EXPORT_TABLES.RESPONDENTS,
        sourceColumn: "caseTeam",
        displayLabel: "Case Team",
        type: CUSTOM_FIELD_TYPES.TEXT,
    },
    {
        key: EDITABLE_COLUMN_KEYS.RESPONDENT_SEX,
        sourceTable: EXPORT_TABLES.RESPONDENTS,
        sourceColumn: "sex",
        displayLabel: "Sex",
        type: CUSTOM_FIELD_TYPES.TEXT,
    },
    {
        key: EDITABLE_COLUMN_KEYS.RESPONDENT_CONTACT_EMAIL,
        sourceTable: EXPORT_TABLES.RESPONDENTS,
        sourceColumn: "contactEmail",
        displayLabel: "Contact Email",
        type: CUSTOM_FIELD_TYPES.TEXT,
    },
    {
        key: EDITABLE_COLUMN_KEYS.RESPONDENT_CONTACT_MOBILE_PHONE,
        sourceTable: EXPORT_TABLES.RESPONDENTS,
        sourceColumn: "contactMobilePhone",
        displayLabel: "Contact Mobile Phone",
        type: CUSTOM_FIELD_TYPES.TEXT,
    },
    {
        key: EDITABLE_COLUMN_KEYS.RESPONDENT_OTP,
        sourceTable: EXPORT_TABLES.RESPONDENTS,
        sourceColumn: "otp",
        displayLabel: "OTP",
        type: CUSTOM_FIELD_TYPES.TEXT,
    },
    {
        key: EDITABLE_COLUMN_KEYS.RESPONDENT_OTP_CREATED_AT,
        sourceTable: EXPORT_TABLES.RESPONDENTS,
        sourceColumn: "otpCreatedAt",
        displayLabel: "OTP Created At",
        type: CUSTOM_FIELD_TYPES.DATE,
    },
    {
        key: EDITABLE_COLUMN_KEYS.RESPONDENT_SPLOSE_ID,
        sourceTable: EXPORT_TABLES.RESPONDENTS,
        sourceColumn: "sploseId",
        displayLabel: "Splose ID",
        type: CUSTOM_FIELD_TYPES.NUMBER,
    },
    {
        key: EDITABLE_COLUMN_KEYS.CASE_ID,
        sourceTable: EXPORT_TABLES.CASES,
        sourceColumn: "id",
        displayLabel: "Case ID",
        type: CUSTOM_FIELD_TYPES.TEXT,
        readOnly: true,
        note: "System generated, unique across all clients",
    },
    {
        key: EDITABLE_COLUMN_KEYS.CASE_CLAIM_NUMBER,
        sourceTable: EXPORT_TABLES.CASES,
        sourceColumn: "claimNumber",
        displayLabel: "Case Claim Number",
        type: CUSTOM_FIELD_TYPES.TEXT,
    },
    {
        key: EDITABLE_COLUMN_KEYS.CASE_TITLE,
        sourceTable: EXPORT_TABLES.CASES,
        sourceColumn: "title",
        displayLabel: "Case Title",
        type: CUSTOM_FIELD_TYPES.TEXT,
    },
    {
        key: EDITABLE_COLUMN_KEYS.CASE_DESCRIPTION,
        sourceTable: EXPORT_TABLES.CASES,
        sourceColumn: "description",
        displayLabel: "Case Description",
        type: CUSTOM_FIELD_TYPES.TEXT,
    },
    {
        key: EDITABLE_COLUMN_KEYS.CASE_STATUS,
        sourceTable: EXPORT_TABLES.CASES,
        sourceColumn: "status",
        displayLabel: "Case Status",
        type: CUSTOM_FIELD_TYPES.SELECT_BOX,
        readOnly: true,
        allowOptionEditing: false,
        options: CASE_STATUS_LABELS,
    },
    {
        key: EDITABLE_COLUMN_KEYS.CASE_CATEGORY,
        sourceTable: EXPORT_TABLES.CASES,
        sourceColumn: "category",
        displayLabel: "Case Category",
        type: CUSTOM_FIELD_TYPES.SELECT_BOX,
        options: [
            "Consultancy - Ergonomics",
            "Consultancy - Fitness for Continued Duties",
            "Consultancy - Human Interventions",
            "Consultancy - OT Services",
            "Consultancy - Premium Management",
            "Consultancy - WHS & OHS Services",
            "Critical Incident",
            "Dust Diseases",
            "Employee Assistance Program",
            "Health Assessment",
            "Health Assessment - Regional",
            "Rehab - Case Management - Pathways",
            "Rehab - Case Management - Same Employer",
            "Rehab - Case Management - Same Employer (LPR)",
            "Rehab - Catastrophic Claim Management",
            "Rehab - Counselling Services",
            "Rehab - CTP Rehabilitation - RTW",
            "Rehab - Single Service - NSWPF",
            "Treatment - MindBody Program",
            "Treatment - Psychological Services",
            "Treatment - Work-Related Activity Program",
            "WorkCover NSW",
            "Workers Care",
            "Workers Insurance (Non ORCode / Non Reported)",
        ],
    },
    {
        key: EDITABLE_COLUMN_KEYS.CASE_SUB_CATEGORY,
        sourceTable: EXPORT_TABLES.CASES,
        sourceColumn: "subCategory",
        displayLabel: "Sub Category",
        type: CUSTOM_FIELD_TYPES.SELECT_BOX,
        options: ["Rehab - Case Management - Same Employer"],
    },
    {
        key: EDITABLE_COLUMN_KEYS.CASE_OPENED_AT,
        sourceTable: EXPORT_TABLES.CASES,
        sourceColumn: "openedAt",
        displayLabel: "Case Opened At",
        type: CUSTOM_FIELD_TYPES.DATE,
    },
    {
        key: EDITABLE_COLUMN_KEYS.CASE_CLOSED_AT,
        sourceTable: EXPORT_TABLES.CASES,
        sourceColumn: "closedAt",
        displayLabel: "Case Closed At",
        type: CUSTOM_FIELD_TYPES.DATE,
    },
    {
        key: EDITABLE_COLUMN_KEYS.CASE_REFERRAL_DATE,
        sourceTable: EXPORT_TABLES.CASES,
        sourceColumn: "referralDate",
        displayLabel: "Referral Date",
        type: CUSTOM_FIELD_TYPES.DATE,
    },
    {
        key: EDITABLE_COLUMN_KEYS.CASE_OCCUPATION_STATUS,
        sourceTable: EXPORT_TABLES.CASES,
        sourceColumn: "occupationStatus",
        displayLabel: "Occupation Status",
        type: CUSTOM_FIELD_TYPES.SELECT_BOX,
        options: [
            "Employed - Full Time",
            "Employed - Part Time",
            "Unemployed - Seeking Work",
            "Unemployed - Not Seeking Work",
            "Student",
            "Retired",
            "Other",
        ],
    },
    {
        key: EDITABLE_COLUMN_KEYS.CASE_FLAG,
        sourceTable: EXPORT_TABLES.CASES,
        sourceColumn: "flag",
        displayLabel: "Flag",
        type: CUSTOM_FIELD_TYPES.TEXT,
    },
    {
        key: EDITABLE_COLUMN_KEYS.CASE_FLAG_NOTES,
        sourceTable: EXPORT_TABLES.CASES,
        sourceColumn: "flagNotes",
        displayLabel: "Flag notes",
        type: CUSTOM_FIELD_TYPES.TEXTAREA,
    },
    {
        key: EDITABLE_COLUMN_KEYS.CASE_FUNDING_AMOUNT,
        sourceTable: EXPORT_TABLES.CASES,
        sourceColumn: "fundingTotalApprovedAmount",
        displayLabel: "Amount",
        type: CUSTOM_FIELD_TYPES.TEXT,
        readOnly: true,
    },
    {
        key: EDITABLE_COLUMN_KEYS.CASE_OUTCOME,
        sourceTable: EXPORT_TABLES.CASES,
        sourceColumn: "outcome",
        displayLabel: "Outcome",
        type: CUSTOM_FIELD_TYPES.SELECT_BOX,
        options: ["Returned to work", "Treatment complete", "Other"],
        readOnly: true,
    },
    {
        key: EDITABLE_COLUMN_KEYS.CLINICAL_CONDITION_NAME,
        sourceTable: EXPORT_TABLES.CLINICAL_CONDITIONS,
        sourceColumn: "name",
        displayLabel: "Name",
        type: CUSTOM_FIELD_TYPES.TEXT,
    },
    {
        key: EDITABLE_COLUMN_KEYS.CLINICAL_CONDITION_TYPE,
        sourceTable: EXPORT_TABLES.CLINICAL_CONDITIONS,
        sourceColumn: "type",
        displayLabel: "Type",
        type: CUSTOM_FIELD_TYPES.TEXT,
    },
    {
        key: EDITABLE_COLUMN_KEYS.CLINICAL_CONDITION_DESCRIPTION,
        sourceTable: EXPORT_TABLES.CLINICAL_CONDITIONS,
        sourceColumn: "description",
        displayLabel: "Description",
        type: CUSTOM_FIELD_TYPES.TEXTAREA,
    },
    {
        key: EDITABLE_COLUMN_KEYS.CLINICAL_CONDITION_CAUSE,
        sourceTable: EXPORT_TABLES.CLINICAL_CONDITIONS,
        sourceColumn: "cause",
        displayLabel: "Cause",
        type: CUSTOM_FIELD_TYPES.TEXT,
    },
    {
        key: EDITABLE_COLUMN_KEYS.CLINICAL_CONDITION_ONSET_AT,
        sourceTable: EXPORT_TABLES.CLINICAL_CONDITIONS,
        sourceColumn: "onsetAt",
        displayLabel: "On set at",
        type: CUSTOM_FIELD_TYPES.DATE,
    },
    {
        key: EDITABLE_COLUMN_KEYS.CLINICAL_CONDITION_REPORTED_AT,
        sourceTable: EXPORT_TABLES.CLINICAL_CONDITIONS,
        sourceColumn: "reportedAt",
        displayLabel: "Reported At",
        type: CUSTOM_FIELD_TYPES.DATE,
    },
    {
        key: EDITABLE_COLUMN_KEYS.CLINICAL_CONDITION_IS_WORK_RELATED,
        sourceTable: EXPORT_TABLES.CLINICAL_CONDITIONS,
        sourceColumn: "isWorkRelated",
        displayLabel: "Is Work Related",
        type: CUSTOM_FIELD_TYPES.BOOLEAN,
    },
    {
        key: EDITABLE_COLUMN_KEYS.CLINICAL_CONDITION_SEVERITY,
        sourceTable: EXPORT_TABLES.CLINICAL_CONDITIONS,
        sourceColumn: "severity",
        displayLabel: "Severity",
        type: CUSTOM_FIELD_TYPES.SELECT_BOX,
        options: ["Low", "Medium", "High", "Extremely high"],
    },
    {
        key: EDITABLE_COLUMN_KEYS.CLINICAL_CONDITION_STATUS,
        sourceTable: EXPORT_TABLES.CLINICAL_CONDITIONS,
        sourceColumn: "status",
        displayLabel: "Status",
        type: CUSTOM_FIELD_TYPES.TEXT,
    },
    {
        key: EDITABLE_COLUMN_KEYS.CLINICAL_CONDITION_NOTES,
        sourceTable: EXPORT_TABLES.CLINICAL_CONDITIONS,
        sourceColumn: "notes",
        displayLabel: "Notes",
        type: CUSTOM_FIELD_TYPES.TEXTAREA,
    },
    {
        key: EDITABLE_COLUMN_KEYS.FUNDING_NAME,
        sourceTable: EXPORT_TABLES.FUNDING,
        sourceColumn: "name",
        displayLabel: "Name",
        type: CUSTOM_FIELD_TYPES.TEXT,
    },
    {
        key: EDITABLE_COLUMN_KEYS.FUNDING_CODE,
        sourceTable: EXPORT_TABLES.FUNDING,
        sourceColumn: "code",
        displayLabel: "Code",
        type: CUSTOM_FIELD_TYPES.TEXT,
    },
    {
        key: EDITABLE_COLUMN_KEYS.FUNDING_TYPE,
        sourceTable: EXPORT_TABLES.FUNDING,
        sourceColumn: "type",
        displayLabel: "Type",
        type: CUSTOM_FIELD_TYPES.TEXT,
    },
    {
        key: EDITABLE_COLUMN_KEYS.FUNDING_DESCRIPTION,
        sourceTable: EXPORT_TABLES.FUNDING,
        sourceColumn: "description",
        displayLabel: "Description",
        type: CUSTOM_FIELD_TYPES.TEXTAREA,
    },
    {
        key: EDITABLE_COLUMN_KEYS.FUNDING_STARTS_AT,
        sourceTable: EXPORT_TABLES.FUNDING,
        sourceColumn: "startsAt",
        displayLabel: "Starts At",
        type: CUSTOM_FIELD_TYPES.DATE,
    },
    {
        key: EDITABLE_COLUMN_KEYS.FUNDING_ENDS_AT,
        sourceTable: EXPORT_TABLES.FUNDING,
        sourceColumn: "endsAt",
        displayLabel: "Ends At",
        type: CUSTOM_FIELD_TYPES.DATE,
    },
    {
        key: EDITABLE_COLUMN_KEYS.FUNDING_STATUS,
        sourceTable: EXPORT_TABLES.FUNDING,
        sourceColumn: "status",
        displayLabel: "Status",
        type: CUSTOM_FIELD_TYPES.TEXT,
    },
    {
        key: EDITABLE_COLUMN_KEYS.FUNDING_CURRENCY,
        sourceTable: EXPORT_TABLES.FUNDING,
        sourceColumn: "currency",
        displayLabel: "Currency",
        type: CUSTOM_FIELD_TYPES.TEXT,
    },
    {
        key: EDITABLE_COLUMN_KEYS.FUNDING_AMOUNT,
        sourceTable: EXPORT_TABLES.FUNDING,
        sourceColumn: "totalApprovedAmount",
        displayLabel: "Amount",
        type: CUSTOM_FIELD_TYPES.TEXT,
        readonly: true,
    },
];
export const findEditableColumnDetail = (key) => EDITABLE_COLUMN_DETAILS.find((detail) => detail.key === key) ?? null;
//# sourceMappingURL=editableColumns.js.map